module.exports = __webpack_public_path__ + "static/img/znjzt.30a1374.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/znjzt.png
// module id = 19lm
// module chunks = 0